import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { getStoredData } from "../../../../json/fecthData";
import { toast } from "react-toastify";
import "./EditTablePopup.css"; // create this CSS file

const EditTablePopup = ({ id, api, fields,onSuccess }) => {
  const [formData, setFormData] = useState({});
  const [dropdownData, setDropdownData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [visible, setVisible] = useState(true);

  const popupRef = useRef(null);

  const configData = getStoredData()?.[1] || {};
  const resolvedFields = configData[fields] || [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mainData = await axios.get(`${api}/${id}`);
        const dropdownResponses = await Promise.all(
          resolvedFields
            .filter((f) => f.api)
            .map((f) =>
              axios.get(f.api).then((res) => ({
                field: f.fields,
                values: res.data.map((item) => ({
                  id: item._id,
                  label: item[f.apiField],
                })),
              }))
            )
        );

        const dropdownMap = {};
        dropdownResponses.forEach(({ field, values }) => {
          dropdownMap[field] = values;
        });

        setFormData(mainData.data);
        setDropdownData(dropdownMap);
      } catch (err) {
        console.error("❌ Failed to fetch data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, api, fields]);

  console.log(formData);

useEffect(() => {
  const fetchData = async () => {
    try {
      const mainData = await axios.get(`${api}/${id}`);

      const dropdownResponses = await Promise.all(
        resolvedFields.flatMap((f) => {
          if (f.api) {
            return [
              axios.get(f.api).then((res) => ({
                field: f.fields,
                values: res.data.map((item) => ({
                  id: item._id,
                  label: item[f.apiField],
                })),
              })),
            ];
          } else if (f.type === "array" && f.subFields) {
            return f.subFields
              .filter((sf) => sf.api)
              .map((sf) =>
                axios.get(sf.api).then((res) => ({
                  field: sf.fields,
                  values: res.data.map((item) => ({
                    id: item._id,
                    label: item[sf.apiField],
                  })),
                }))
              );
          }
          return [];
        })
      );

      const dropdownMap = {};
      dropdownResponses.forEach(({ field, values }) => {
        dropdownMap[field] = values;
      });

      setFormData(mainData.data);
      setDropdownData(dropdownMap);
    } catch (err) {
      console.error("❌ Failed to fetch data:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id, api, fields]);

const addSubArrayEntry = (fieldKey, subFields) => {
  setFormData((prev) => ({
    ...prev,
    [fieldKey]: [
      ...(prev[fieldKey] || []),
      subFields.reduce((acc, sf) => {
        acc[sf.fields] = sf.type === "number" ? 0 : "";
        return acc;
      }, {}),
    ],
  }));
};

const deleteSubArrayEntry = (fieldKey, index) => {
  setFormData((prev) => {
    const updated = [...(prev[fieldKey] || [])];
    updated.splice(index, 1);
    return { ...prev, [fieldKey]: updated };
  });
};





  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${api}/${id}`, formData);
      toast.success("✅ Saved successfully!");
      setVisible(false);
    } catch (err) {
      console.error("❌ Failed to save:", err);
      toast.error("❌ Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="modal-overlay"><div className="popup-box">Loading...</div></div>;
  if (!visible) return null;


  return (
    <div className="modal-overlay">
      <div className="popup-box" ref={popupRef}>
        <form onSubmit={handleSubmit}>
          <div className="popup-header">
  <h3>Edit Entry</h3>
 <button type="button" className="popup-close-btn" onClick={() => setVisible(false)}>
  ✕
</button>
</div>

{resolvedFields.map((field) => {
  const value = formData[field.fields] ?? "";
  const isReadOnly = field.edit === "no";

  // ✅ Handle arrays with subFields
  if (field.type === "array" && Array.isArray(value) && field.subFields) {
    return (
      <div key={field.fields} className="form-group array-field">
        <label>{field.title}</label>
        {value.map((entry, idx) => (
  <div key={idx} className="array-entry">
    <div className="array-entry-header">
      <strong>Entry {idx + 1}</strong>
      <button
        type="button"
        className="array-remove-btn"
        onClick={() => deleteSubArrayEntry(field.fields, idx)}
      >
        ✕
      </button>
    </div>

            {field.subFields.map((sub) => {
              const subVal = entry[sub.fields] ?? "";
              const subDropdown = dropdownData[sub.fields] || [];
              const subReadOnly = sub.edit === "no";

              return (
                <div key={sub.fields} className="form-subfield">
                  <label>{sub.title}</label>
                  {sub.type === "ObjectId" && sub.api ? (
                    <select
                      value={typeof subVal === "object" ? subVal._id : subVal}
                      onChange={(e) => {
                        const updated = [...value];
                        updated[idx][sub.fields] = e.target.value;
                        handleChange(field.fields, updated);
                      }}
                      disabled={subReadOnly}
                    >
                      <option value="">Select</option>
                      {subDropdown.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={sub.type === "number" ? "number" : "text"}
                      value={subVal}
                      onChange={(e) => {
                        const updated = [...value];
                        updated[idx][sub.fields] =
                          sub.type === "number"
                            ? +e.target.value
                            : e.target.value;
                        handleChange(field.fields, updated);
                      }}
                      readOnly={subReadOnly}
                    />
                  )}
                </div>
              );
            })}
          </div>
          
        ))}
        <button
  type="button"
  className="array-add-btn"
  onClick={() => addSubArrayEntry(field.fields, field.subFields)}
>
  + Add Entry
</button>

      </div>
    );
  }

  

  // 🔁 Fallback for all other types
  return (
    <div key={field.fields} className="form-group">
      <label>{field.title}</label>
      {field.type === "text" || field.type === "number" ? (
        <input
          type={field.type}
          value={value}
          readOnly={isReadOnly}
          onChange={(e) =>
            handleChange(
              field.fields,
              field.type === "number" ? +e.target.value : e.target.value
            )
          }
        />
      ) : field.type === "date" ? (
        <input
          type="date"
          value={value?.slice(0, 10)}
          readOnly={isReadOnly}
          onChange={(e) => handleChange(field.fields, e.target.value)}
        />
      ) : field.type === "dropdown" ? (
        <select
          value={value}
          onChange={(e) => handleChange(field.fields, e.target.value)}
          disabled={isReadOnly}
        >
          <option value="">Select</option>
          {field.options?.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : field.type === "ObjectId" && field.api ? (
        <select
          value={typeof value === "object" ? value._id : value}
          onChange={(e) => handleChange(field.fields, e.target.value)}
          disabled={isReadOnly}
        >
          <option value="">Select</option>
          {dropdownData[field.fields]?.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type="text"
          value={value}
          readOnly={isReadOnly}
          onChange={(e) => handleChange(field.fields, e.target.value)}
        />
      )}
    </div>
  );
})}

          <div className="modal-actions">
            <button type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTablePopup;
